import { Col, Typography, Row, Progress } from "antd";
import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { getProfileCompletion } from "../../Redux/client/reducer";
import { StyledLink } from "../../styled-components/components";
import { HiExternalLink } from "react-icons/hi";

const ClientProfileCompletion = (props) => {
  const history = useHistory();
  const { fetchProfileCompletion } = props;
  useEffect(() => {
    const getProfile = async () => {
      await fetchProfileCompletion();
    };
    getProfile();
  }, [fetchProfileCompletion]);
  const { profileCompletion } = useSelector((state) => state.clientStore);
  return (
    <Col
      xl={{ span: 10 }}
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginLeft: "auto",
        marginRight: "12vh",
      }}
    >
      {profileCompletion === 100 ? null : (
        <Col
          xl={{ span: 4 }}
          style={{
            padding: "1vh",
            background: "#ffffff",
            border: "1px solid #f4f4f4",
            margin: "2vh",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "2vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "fixed",
          }}
        >
          <Col>
            <Progress
              width={70}
              type="circle"
              percent={Math.floor(profileCompletion / 10) * 10}
            />
          </Col>
          <Col>
            <Row align="middle">
              <Typography.Text>
                Complete Your Profile
                <StyledLink
                  data-testid="submit-complete-profile"
                  onClick={() => history.push("/client/profile/account")}
                >
                  <HiExternalLink style={{ color: "#1565d8" }} />
                </StyledLink>
              </Typography.Text>
            </Row>
          </Col>
        </Col>
      )}
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProfileCompletion: () => dispatch(getProfileCompletion()),
  };
};

export default connect(null, mapDispatchToProps)(ClientProfileCompletion);
